module.exports = __webpack_public_path__ + "img/Philippe Hunzikersm.f8bc80d8.jpg";